import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { CurvaAbcVendaReportModalComponent } from './curva-abc-venda-report-modal.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CurvaAbcVendaReportModalComponent
    ],
    exports: [
        CurvaAbcVendaReportModalComponent
    ]
})
export class CurvaAbcVendaReportModalModule { }
